import { useEffect, useState } from "react";
import api from "../../lib/api";
import DashboardLayout from "../../components/layout/DashboardLayout";
import { formatDateTime } from "../../lib/format";

export default function MyDownloads() {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/me/downloads").then(({ data }) => setLogs(data || [])).finally(() => setLoading(false));
    }, []);

    return (
        <DashboardLayout role="client">
            <div className="mb-8" data-testid="my-downloads-page">
                <div className="label-mono mb-3">/ Download history</div>
                <h1 className="font-heading font-black text-3xl lg:text-4xl tracking-tighter">Descargas</h1>
                <p className="text-avx-muted mt-2">Every time you download an installer, it is logged here.</p>
            </div>

            {loading ? (
                <div className="text-avx-muted font-mono">Loading…</div>
            ) : logs.length === 0 ? (
                <div className="panel p-10 text-center text-avx-muted">You haven't downloaded any installers yet.</div>
            ) : (
                <div className="panel overflow-hidden">
                    <table className="w-full text-sm">
                        <thead className="bg-avx-surface/80 border-b border-avx-line">
                            <tr className="label-mono text-left">
                                <th className="px-4 py-3 font-normal">Product</th>
                                <th className="px-4 py-3 font-normal">System</th>
                                <th className="px-4 py-3 font-normal">Version</th>
                                <th className="px-4 py-3 font-normal">File</th>
                                <th className="px-4 py-3 font-normal">Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {logs.map((l) => (
                                <tr key={l.id} className="border-b border-avx-line/60 hover:bg-avx-surface/40 transition-colors">
                                    <td className="px-4 py-3">{l.product_name || "—"}</td>
                                    <td className="px-4 py-3 font-mono text-avx-muted">{l.os}</td>
                                    <td className="px-4 py-3 font-mono">{l.version}</td>
                                    <td className="px-4 py-3 font-mono text-xs text-avx-muted truncate max-w-[200px]">{l.file_name || "—"}</td>
                                    <td className="px-4 py-3 font-mono text-xs">{formatDateTime(l.downloaded_at)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </DashboardLayout>
    );
}
